export const MODULE_IDS = {
  BACKOFFICE: 9000,
} as const

export const OAUTH_REDIRECT_URIS = {
  GOOGLE: 'https://app.toteat.com/shared/loginret.html',
  FACEBOOK: 'https://app.toteat.com/shared/loginret.html',
  VKONTAKT: 'https://app.toteat.com/shared/loginret.html',
  LINKEDIN: 'https://app.toteat.com/shared/loginret.html',
  APPLE: 'https://app.toteat.com/login/loginapple',
} as const

export const OAUTH_CLIENT_IDS = {
  GOOGLE: '443557042324.apps.googleusercontent.com',
  FACEBOOK: '173372379487489',
  VKONTAKT: '3807527',
  LINKEDIN: 'mlm2uiy9l7jd',
  APPLE: 'com.toteat.login',
} as const

